// 사용자 로그인 유휴 만료(기본 1시간). 화면 조작과 학습만 활동으로 친다. 자동 조회·토큰 갱신은 활동이 아니다.
// 마지막 활동 시각은 localStorage로 탭끼리 공유한다. 서버(POST /api/user/auth/activity, 학습 하트비트)도 같은 기준으로 만료를 판정한다.
export const USER_IDLE_MS = 60 * 60 * 1000
export const ACTIVITY_PING_MS = 2 * 60 * 1000
export const ACTIVITY_STORAGE_KEY = 'techedu-user-last-active'

/**
 * @param {{ now?: () => number, storage?: Storage, ping: () => Promise<unknown>, isLoggedIn: () => boolean, onIdle: () => Promise<void>|void, idleMs?: number, pingMs?: number }} options
 */
export function createUserActivity({ now = Date.now, storage, ping, isLoggedIn, onIdle, idleMs = USER_IDLE_MS, pingMs = ACTIVITY_PING_MS }) {
  function read() { try { const value = Number(storage?.getItem(ACTIVITY_STORAGE_KEY)); return Number.isFinite(value) && value > 0 ? value : null } catch { return null } }
  function write(value) { try { storage?.setItem(ACTIVITY_STORAGE_KEY, String(value)) } catch { /* 저장소를 못 써도 이 탭 기준으로 판정한다. */ } }
  let last = read() ?? now(), lastPing = 0, ending = false
  // 다른 탭의 더 늦은 활동을 반영한다.
  function sync() { const value = read(); if (value && value > last) last = value }
  /** 활동 기록. remote가 true면 로그인 중일 때 서버에도 알린다(pingMs마다 한 번). 학습 하트비트는 서버가 이미 기록하므로 remote: false로 부른다. */
  function mark({ remote = true } = {}) {
    const time = now()
    if (time > last) { last = time; write(time) }
    if (remote && isLoggedIn() && time - lastPing >= pingMs) { lastPing = time; Promise.resolve().then(ping).catch(() => { lastPing = 0 }) }
  }
  function idle() { sync(); return now() - last >= idleMs }
  /** 로그인 중이고 유휴 시간이 지났으면 onIdle(로그아웃)을 한 번 실행한다. */
  async function check() {
    if (ending || !isLoggedIn() || !idle()) return false
    ending = true
    try { await onIdle() } finally { ending = false }
    return true
  }
  return { mark, idle, check, lastActive: () => last }
}
